export const getButtonStyle = (style, size, enableFullWidth) => {
	const styleClass = {
		primary: "btn-primary",
		secondary: "btn-secondary",
		tertiary: "btn-tertiary",
		"tertiary-black": "btn-tertiary-black",
		"tertiary-white": "btn-tertiary-white",
		quaternary: "btn-quaternary",
		quinary: "btn-quinary",
		senary: "btn-senary",
		cyan: "btn-cyan",
		"black-red-border": "btn-black-red-border",
		gradient: "btn-gradient-border",
	};

	const sizeClass = size === "sm" ? "btn-sm" : "";
	const fullWidthClass = enableFullWidth ? "w-full sm:w-fit" : "";

	return `${styleClass[style || "primary"]} ${sizeClass} ${fullWidthClass}`;
};
